export const QBR_SETTINGS_FORM_KEY = 'QBR_SETTINGS_FORM_KEY'
